import { useState, useEffect } from "react";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue
} from "firebase/remote-config";

const configCache = new Map();

export function useRemoteConfig(configKey, defaultValue) {
  // Check if we have a cached value first
  const cachedValue = configCache.get(configKey);

  const [value, setValue] = useState(
    cachedValue !== undefined ? cachedValue : defaultValue
  );
  const [loading, setLoading] = useState(
    cachedValue !== undefined ? false : true
  );
  const [error, setError] = useState(null);

  useEffect(() => {
    // If we already have a cached value, don't fetch again
    if (cachedValue !== undefined) return;

    const fetchConfig = async () => {
      try {
        const remoteConfig = getRemoteConfig();

        // Fetch and activate the config
        await fetchAndActivate(remoteConfig);

        // Get value
        const configValue = getValue(remoteConfig, configKey);
        // Parse the value based on its type
        if (configValue.getSource() !== "default") {
          setValue(configValue.asString());
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetching remote config:", err);
        setError(err);
        setLoading(false);
      }
    };

    fetchConfig();
  }, [configKey, defaultValue, cachedValue]);

  return { value, loading, error };
}
